import { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { Navigate } from "react-router-dom";

import Navbar from "../../../components/Navbar";
import zipzyAdminApiClient from "../../../apiClients/zipzyAdminApiClient";

export default function AddUserPage() {
  const isLoggedIn = zipzyAdminApiClient.isLoggedIn();

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isAddingNewUser, setIsAddingNewUser] = useState(false);

  const addNewUserViaApi = async () => {
    if (fullName.trim().length < 3) {
      window.alert("Please enter a valid name (at least 3 characters).");
      return;
    }

    if (phoneNumber.trim().length < 10) {
      window.alert("Please enter a valid Indian mobile phone number (at least 10 digits).");
      return;
    }

    setIsAddingNewUser(true);
    const response = await zipzyAdminApiClient.addNewUser(fullName, phoneNumber);
    if (!response.success) {
      window.alert(response.error.userFriendlyMessage);
      setIsAddingNewUser(false);
      return;
    }

    const alertMessage = `User ${response.data.user.fullName} added successfully with phone number ${response.data.user.phoneNumber}.`;
    window.alert(alertMessage);

    setFullName("");
    setPhoneNumber("");

    setIsAddingNewUser(false);
  };

  if (!isLoggedIn) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      height="100vh"
      textAlign="center"
    >
      <Navbar />

      <Box
        sx={{
          mb: 4,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          width: "90%",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
          }}
        >
          Add A New User
        </Typography>
      </Box>

      <Box
        sx={{
          width: "90%",
          maxWidth: 400,
        }}
      >
        <TextField
          label="Full Name"
          fullWidth
          margin="normal"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />

        <TextField
          label="Phone Number"
          fullWidth
          margin="normal"
          value={phoneNumber}
          onChange={(e) => {
            const raw = e.target.value;
            const cleaned = raw.replace(/[^0-9+]/g, "");
            setPhoneNumber(cleaned);
          }}
          inputProps={{
            inputMode: "numeric", // Shows numeric keyboard on mobile (with + on most devices)
            pattern: "[0-9+]*", // Only allow digits and plus symbol
          }}
        />

        <Button variant="contained" fullWidth onClick={addNewUserViaApi} disabled={isAddingNewUser} sx={{ mt: 2 }}>
          {isAddingNewUser ? <CircularProgress size={24} /> : "Add User"}
        </Button>
      </Box>
    </Box>
  );
}
